var _ref2;

const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

const SvgBooking = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 26.262,
      height: 26.262,
      viewBox: "0 0 26.262 26.262",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2 || (_ref2 =
    /*#__PURE__*/
    React.createElement("path", {
      id: "_001-calendar",
      "data-name": "001-calendar",
      d: "M22.98,3.283H21.886V1.094A1.1,1.1,0,0,0,20.791,0H19.7A1.1,1.1,0,0,0,18.6,1.094V3.283H7.66V1.094A1.1,1.1,0,0,0,6.566,0H5.471A1.1,1.1,0,0,0,4.377,1.094V3.283H3.283A3.287,3.287,0,0,0,0,6.566V22.98a3.287,3.287,0,0,0,3.283,3.283h19.7a3.287,3.287,0,0,0,3.283-3.283V6.566A3.287,3.287,0,0,0,22.98,3.283Zm1.094,19.7a1.1,1.1,0,0,1-1.094,1.094H3.283A1.1,1.1,0,0,1,2.189,22.98V10.987H24.074Zm0,0"
    })))
  );
};

const ForwardRef =
/*#__PURE__*/
React.forwardRef((props, ref) =>
/*#__PURE__*/
React.createElement(SvgBooking, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Booking.f9e334ae.svg";
export { ForwardRef as ReactComponent };